export default {
  header: {
    reserve: 'Broneeri koht(id)',
    finalize: 'Lõpeta broneering'
  },
  home: {
    legend: {
      available: 'Vaba',
      reserved: 'Reserveeritud',
      booked: 'Broneeritud'
    },
    summary: {
      selected: '{count} koht valitud | {count} kohta valitud',
      total: 'Koguhind: {price}€',
      clear: '✖ Tühjenda valik',
      continue: 'Jätka →'
    },
    error: {
      title: 'Paistab, et keegi oli kiirem!',
      message: 'Teie valitud koht on juba reserveeritud. Vaadake teisi saadaval olevaid kohti.',
      button: 'VALI UUS KOHT'
    }
  },
  booking: {
    heading: 'Broneeringu andmed',
    back: 'Tagasi',
    fields: {
      country: 'Riik',
      firstName: 'Eesnimi',
      lastName: 'Perekonnanimi',
      phone: 'Telefoninumber',
      email: 'E-post',
      company: 'Ettevõtte nimi',
      registration: 'Registrikood',
      description: 'Toote kirjeldus',
      comments: 'Lisakommentaarid',
      commentsOptional: '(valikuline)',
      vatNumber: 'KMKR number'
    },
    countries: {
      latvia: 'Läti',
      lithuania: 'Leedu',
      estonia: 'Eesti',
      other: 'Muu'
    },
    errors: {
      country: 'Palun valige oma riik',
      firstName: 'Palun sisestage oma eesnimi',
      lastName: 'Palun sisestage oma perekonnanimi',
      phone: 'Palun sisestage oma telefoninumber',
      email: 'Palun sisestage kehtiv e-posti aadress',
      company: 'Palun sisestage ettevõtte nimi',
      registration: 'Palun sisestage registrikood',
      description: 'Palun kirjeldage oma toodet',
      terms: 'Palun nõustuge tingimustega',
      vatNumber: 'Palun sisestage oma KMKR number'
    },
    inboxError: '{domain} e-posti aadresse ei aktsepteerita tarneprobleemide tõttu. Palun kasutage teist aadressi.',
    termsLink: 'TINGIMUSED',
    termsText: 'Olen lugenud {link} ja nõustun nendega.',
    vat: {
      text: 'Minu ettevõte on registreeritud käibemaksukohustuslane ja omab kehtivat KMKR numbrit, mis on väljastatud Leedus, Eestis või mõnes teises Euroopa Liidu riigis (<u>!MITTE Lätis!</u>). Seetõttu peaks tehingule rakenduma pöördmaksustamise mehhanism (0% KM).',
      hint: 'nt EE123456789; LT12345679; LT123456789012',
      footnote: '*KM direktiiv 2006/112/EÜ Art.44, Art.196<br> Maksustamine (KM) saaja riigis.<br> Pöördmaksustamine'
    },
    vatLabel: 'KM',
    total: 'KOKKU:',
    confirm: 'Kinnita broneering'
  },
  tooltip: {
    status: {
      available: 'Vaba',
      reserved: 'Reserveeritud',
      booked: 'Broneeritud'
    },
    dimensions: 'Mõõdud: 3x2 m',
    select: 'VALI KOHT',
    deselect: 'TÜHISTA VALIK'
  },
  map: {
    foodCourt: 'TOIDUALA JA PARTNERITE PROMOTSOON',
    kidsWorkshops: 'LASTE TÖÖTOAD',
    entrance: 'SISSEPÄÄS',
    gate: 'VÄRAV #{n}',
    foodSellers: 'TOIDUMÜÜJAD',
    kidsInflatables: 'LASTE TÄISPUHUTAVATE ATRAKTSIOONIDE ALA JA',
    partnersPromoZone: 'PARTNERITE PROMOTSOON'
  },
  thankyou: {
    heading: 'Aitäh!',
    line1: 'Teie kohtade registreerimine on vastu võetud.',
    line2: 'Peagi saadame teile e-postiga arve ja lisainfo!',
    returnHome: 'Tagasi avalehele',
    processing: 'Palun oodake, arvet genereeritakse…',
    processingStep1: 'Arvet genereeritakse…',
    processingStep2: 'Kinnitusmeili saatmine…',
    processingNote: 'Palun ärge sulgege seda lehte.',
    registrationStartsIn: 'Registreerimine algab',
    days: 'Päeva',
    hours: 'Tundi',
    minutes: 'Minutit',
    seconds: 'Sekundit'
  }
}
